 export const EstateSkeletonLoader = ()=>{
    return ( 
         <div className="w-[317px] p-5 rounded-lg bg-gray-100 shadow-sm">
         {/* Title and State */}
      <div className="flex flex-col gap-1">
        <div className="h-5 bg-gray-300 rounded w-1/2 mb-[4px]"></div>
        <div className="h-[12px] bg-gray-300 rounded w-3/4"></div>
      </div>

      {/* Verified, Owner, and Buttons */}
      <div className="flex justify-between mt-10">
        {/* Status */}
        <div className="flex flex-col items-start gap-1">
          <div className="h-6 bg-gray-300 rounded w-14 mb-2"></div>
          <div className="h-4 bg-gray-300 rounded w-10"></div>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-2">
          <div className="h-9 bg-gray-300 rounded w-32"></div>  
        </div>
      </div>
        </div>
        )
    }
